import { useCallback } from "react";

import {
    subscribeUserMarketingService,
    UserMarketingRequestAttributes,
} from "~/services/api/services/klaviyo";

import { formatToE164PhoneNumber } from "~/utils/formatPhoneNumber";
import { setStorageItem } from "~/lib/storage/Storage";
import { STORAGE_KEYS } from "~/types/Storage";

export const useSubscribeKlaviyoUserForMarketing = () => {
    return useCallback((email: string, phone?: string) => {
        if (!email) return Promise.resolve();

        const attributes: UserMarketingRequestAttributes = {
            email: email,
            subscriptions: {
                email: {
                    marketing: { consent: "SUBSCRIBED" }
                },
            },
        };

        if (phone) {
            attributes.phone_number = formatToE164PhoneNumber(phone);

            attributes.subscriptions.sms = {
                marketing: { consent: "SUBSCRIBED" },
                transactional: { consent: "SUBSCRIBED" },
            };
        }

        const list = phone ? "XBaEEZ" : "XrnHMg";

        const data = {
            type: "subscription",
            attributes: {
                profile: {
                    data: {
                        type: "profile",
                        attributes,
                    }
                }
            },
            relationships: {
                list: {
                    data: { type: "list", id: list }
                }
            }
        };

        return subscribeUserMarketingService(data).then(() => {
            if (phone) {
                setStorageItem(STORAGE_KEYS.MARKETING_CONSENT, "true");
            }
        }).catch(console.error);
    }, []);
}